import { defineMessages } from 'react-intl';

export default defineMessages({
  pageDescriptionBold: {
    id: 'fastCover.tugo.tripInterruption.pageDescriptionBold',
    defaultMessage: 'This section relates to expenses incurred as a result of the interruption of your trip after departure.',
  },
  pageDescriptionBody: {
    id: 'fastCover.tugo.tripInterruption.pageDescriptionBody',
    defaultMessage: 'Benefits will only be payable if the trip has been interrupted as a result of one of the covered risks listed here and in your policy booklet. Refer to your policy for a description of the benefits applicable to the covered risks, and select the risk that applies to your cancellation reason below. Please also refer to your policy booklet for exclusions and restrictions that may apply to each covered reason.',
  },
  whatTypeOfExpensesQuestion: {
    id: 'fastCover.tugo.tripInterruption.whatTypeOfExpensesQuestion',
    defaultMessage: 'What type of expenses are you claiming for? Choose all that apply.',
  },
  expenseTypeHealth: {
    id: 'fastCover.tugo.tripInterruption.expenseTypeHealth',
    defaultMessage: 'Trip interruption reasons related to health',
  },
  expenseTypePregnancyAndAdoption: {
    id: 'fastCover.tugo.tripInterruption.expenseTypePregnancyAndAdoption',
    defaultMessage: 'Trip interruption reasons related to pregnancy and adoption',
  },
  expenseTypeEmploymentAndEducation: {
    id: 'fastCover.tugo.tripInterruption.expenseTypeEmploymentAndEducation',
    defaultMessage: 'Trip interruption reasons related to employment and education',
  },
  expenseTypeLegalIssues: {
    id: 'fastCover.tugo.tripInterruption.expenseTypeLegalIssues',
    defaultMessage: 'Trip interruption reasons related to legal issues',
  },
  expenseTypeCancellationsDelaysCarrierWeather: {
    id: 'fastCover.tugo.tripInterruption.expenseTypeCancellationsDelaysCarrierWeather',
    defaultMessage: 'Trip interruption reasons related to cancellations and delays by carrier, accident or weather',
  },
  expenseTypeOtherReasons: {
    id: 'fastCover.tugo.tripInterruption.expenseTypeOtherReasons',
    defaultMessage: 'Other reasons for trip interruption',
  },
  otherReasonsClaimNaturalDisaster: {
    id: 'fastCover.tugo.tripInterruption.otherReasonsClaimNaturalDisaster',
    defaultMessage: 'Is your claim related to a natural disaster, which renders your or your travelling companion\'s principal residence uninhabitable or place of business inoperative?',
  },
  otherReasonsClaimUnforeseeableEvent: {
    id: 'fastCover.tugo.tripInterruption.otherReasonsClaimUnforeseeableEvent',
    defaultMessage: 'Is your claim related to an unforeseeable event completely independent of any intentional or negligent act which renders your or your travelling companion\'s principal residence uninhabitable or place of business inoperative.',
  },
  pregnancyAdoptionClaimLegalAdoption: {
    id: 'fastCover.tugo.tripInterruption.pregnancyAdoptionClaimLegalAdoption',
    defaultMessage: 'Is your claim related to you or your travelling companion being notified that the actual date of a legal adoption of a child by you or your travelling companion is scheduled to take place during your trip?',
  },
  employmentEducationClaimJobTransfer: {
    id: 'fastCover.tugo.tripInterruption.employmentEducationClaimJobTransfer',
    defaultMessage: 'Is your claim related to you, your spouse or your travelling companion\'s job transfer which results in the relocation of your or your travelling companion\'s principal residence?',
  },
  employmentEducationClaimInvoluntaryLossEmployment: {
    id: 'fastCover.tugo.tripInterruption.employmentEducationClaimInvoluntaryLossEmployment',
    defaultMessage: 'Is your claim related to involuntary loss of your, your spouse\'s, your travelling companion\'s or your travelling companion\'s spouse\'s permanent employment (excluding contract or self-employment)?',
  },
  employmentEducationClaimBusinessMeetingCancellation: {
    id: 'fastCover.tugo.tripInterruption.employmentEducationClaimBusinessMeetingCancellation',
    defaultMessage: 'Is your claim for costs directly related to cancellation of a business meeting at your destination beyond your, your travelling companion, or the employer\'s control?',
  },
  employmentEducationClaimConferenceCancellation: {
    id: 'fastCover.tugo.tripInterruption.employmentEducationClaimConferenceCancellation',
    defaultMessage: 'Is your claim related to the cancellation of a conference, seminar, workshop, convention, symposium or retreat at your or your travelling companion\'s destination that is beyond your or your travelling companion\'s control.',
  },
  legalIssuesClaimJuryDuty: {
    id: 'fastCover.tugo.tripInterruption.legalIssuesClaimJuryDuty',
    defaultMessage: 'Is your claim related to you or your travelling companion being subpoenaed for jury duty, as a witness, or being required to appear at a court proceeding during the period of travel?',
  },
  legalIssuesClaimMilitaryService: {
    id: 'fastCover.tugo.tripInterruption.legalIssuesClaimMilitaryService',
    defaultMessage: 'Is your claim related to You or your travelling companion being summoned to police, fire, paramedic or military service (active or reserve).',
  },
  legalIssuesClaimTravelAdvisory: {
    id: 'fastCover.tugo.tripInterruption.legalIssuesClaimTravelAdvisory',
    defaultMessage: 'Is your trip interruption claim related to an official travel advisory issued after your departure by a Canadian Government stating to "avoid all travel" or "avoid non-essential travel" to any of your travel destinations (including any stopovers, layovers or any other destinations you are transiting through? ), provided such travel advisory was issued for your scheduled travel dates and this Insurance was purchased before the travel advisory being issued?',
  },
  cancellationsDelaysCarrierWeatherClaimMissedConnection: {
    id: 'fastCover.tugo.tripInterruption.cancellationsDelaysCarrierWeatherClaimMissedConnection',
    defaultMessage: 'Is your claim related to the earlier departure, the later departure or the later arrival of your or your travelling companion\'s common carrier causing a missed connection?',
  },
  cancellationsDelaysCarrierWeatherClaimFourHoursNoConnection: {
    id: 'fastCover.tugo.tripInterruption.cancellationsDelaysCarrierWeatherClaimFourHoursNoConnection',
    defaultMessage: 'Is your claim related to the earlier departure, the later departure or the later arrival of your or your travelling companion\'s common carrier by at least 4 hours when there is no connection?',
  },
  cancellationsDelaysCarrierWeatherClaimCancellationOfCommonCarrier: {
    id: 'fastCover.tugo.tripInterruption.cancellationsDelaysCarrierWeatherClaimCancellationOfCommonCarrier',
    defaultMessage: 'Is your claim related to the cancellation of a common carrier for any reason other than bankruptcy, insolvency or quarantine?',
  },
  cancellationsDelaysCarrierWeatherClaimTourOperatorCancellation: {
    id: 'fastCover.tugo.tripInterruption.cancellationsDelaysCarrierWeatherClaimTourOperatorCancellation',
    defaultMessage: 'Is your claim related to the cancellation of your or your travelling companion\'s tour by the tour operator?',
  },
  cancellationsDelaysCarrierWeatherClaimAccidentOnWay: {
    id: 'fastCover.tugo.tripInterruption.cancellationsDelaysCarrierWeatherClaimAccidentOnWay',
    defaultMessage: 'Is your claim related to an accident on the way to the departure point involving a private vehicle in which you are a passenger or driver; or a common carrier in which you are a passenger?',
  },
  cancellationsDelaysCarrierWeatherClaimDelayOfPrivateVehicle: {
    id: 'fastCover.tugo.tripInterruption.cancellationsDelaysCarrierWeatherClaimDelayOfPrivateVehicle',
    defaultMessage: 'Is your claim related to the delay of a private vehicle resulting from mechanical failure of the vehicle, weather conditions, earthquakes, volcanic eruptions, a traffic accident, or an emergency police-directed road closure?',
  },
  nonRefundableUnusedTourCost: {
    id: 'fastCover.tugo.tripInterruption.nonRefundableUnusedTourCost',
    defaultMessage: 'Non-refundable Unused Tour Cost',
  },
  returnToDeparturePoint: {
    id: 'fastCover.tugo.tripInterruption.returnToDeparturePoint',
    defaultMessage: 'Return to Departure Point',
  },
  returnToDeparturePointTooltip: {
    id: 'fastCover.tugo.tripInterruption.returnToDeparturePointTooltip',
    defaultMessage: 'Up to a maximum of $1,000, for the lesser of the change fees charged by the common carrier involved to return you to the original departure point OR for the extra cost of a one-way economy airfare on a commercial flight via the most direct route to return you to your original departure point, if cancellation occurs prior to the departure of the tour but after your departure.',
  },
  healthClaimSelfOrCompanion: {
    id: 'fastCover.tugo.tripInterruption.healthClaimSelfOrCompanion',
    defaultMessage: 'Is your claim related to a medical condition, death or quarantine of you or your travelling companion?',
  },
  healthClaimFamilyMember: {
    id: 'fastCover.tugo.tripInterruption.healthClaimFamilyMember',
    defaultMessage: 'Is your claim related to a medical condition, death or quarantine of your family member or your travelling companion\'s family member?',
  },
  healthClaimBusinessPartnerEtc: {
    id: 'fastCover.tugo.tripInterruption.healthClaimBusinessPartnerEtc',
    defaultMessage: 'Is your claim related to a medical condition or death of your or your travelling companion\'s business partner, employer or key employee, caregiver, or death of a friend not travelling with you on the trip?',
  },
  healthClaimHostAtDestination: {
    id: 'fastCover.tugo.tripInterruption.healthClaimHostAtDestination',
    defaultMessage: 'Is your claim related to a medical condition, death or quarantine of your host at your destination?',
  },
  travelCostsTransport: {
    id: 'fastCover.tugo.tripInterruption.travelCostsTransport',
    defaultMessage: 'Travel costs related to transportation',
  },
  travelCostsTransportTooltip: {
    id: 'fastCover.tugo.tripInterruption.travelCostsTransportTooltip',
    defaultMessage: 'Reimbursement is only for ONE of the following:',
  },
  travelCostsTransportTooltip1: {
    id: 'fastCover.tugo.tripInterruption.travelCostsTransportTooltip1',
    defaultMessage: 'Non refundable unused prepaid airfare costs; OR',
  },
  travelCostsTransportTooltip2: {
    id: 'fastCover.tugo.tripInterruption.travelCostsTransportTooltip2',
    defaultMessage: 'The change fees; OR',
  },
  travelCostsTransportTooltip3: {
    id: 'fastCover.tugo.tripInterruption.travelCostsTransportTooltip3',
    defaultMessage: 'The cost of a one way economy airfare to the original departure point to return earlier or later than planned; OR',
  },
  travelCostsTransportTooltip4: {
    id: 'fastCover.tugo.tripInterruption.travelCostsTransportTooltip4',
    defaultMessage: 'A medically necessary airline seat upgrade; OR',
  },
  travelCostsTransportTooltip5: {
    id: 'fastCover.tugo.tripInterruption.travelCostsTransportTooltip5',
    defaultMessage: 'Transportation costs or one way economy airfare to catch-up to your next travel destination.',
  },
  nonRefundablePrepaidAirfare: {
    id: 'fastCover.tugo.tripInterruption.nonRefundablePrepaidAirfare',
    defaultMessage: 'Non Refundable unused Pre-Paid airfare costs',
  },
  nonRefundablePrepaidAirfareTooltip: {
    id: 'fastCover.tugo.tripInterruption.nonRefundablePrepaidAirfareTooltip',
    defaultMessage: 'Non refundable unused prepaid airfare costs',
  },
  changeFees: {
    id: 'fastCover.tugo.tripInterruption.changeFees',
    defaultMessage: 'Change Fees',
  },
  changeFeesTooltip: {
    id: 'fastCover.tugo.tripInterruption.changeFeesTooltip',
    defaultMessage: 'Change fees',
  },
  airfareReturnDeparturePoint: {
    id: 'fastCover.tugo.tripInterruption.airfareReturnDeparturePoint',
    defaultMessage: 'Airfare to return to the departure point earlier or later than planned',
  },
  airfareReturnDeparturePointTooltip: {
    id: 'fastCover.tugo.tripInterruption.airfareReturnDeparturePointTooltip',
    defaultMessage: 'One way economy airfare to the original departure point to return earlier or later than planned',
  },
  medicallyNecessarySeatUpgrade: {
    id: 'fastCover.tugo.tripInterruption.medicallyNecessarySeatUpgrade',
    defaultMessage: 'Medically necessary airline seat upgrade',
  },
  transportCatchUpDestination: {
    id: 'fastCover.tugo.tripInterruption.transportCatchUpDestination',
    defaultMessage: 'Transportation costs or a one-way economy air fare to catch up to your next travel destination',
  },
  nonRefundablePrepaidTravelOther: {
    id: 'fastCover.tugo.tripInterruption.nonRefundablePrepaidTravelOther',
    defaultMessage: 'Non-refundable prepaid travel costs (other than transportation)',
  },
  singleSupplement: {
    id: 'fastCover.tugo.tripInterruption.singleSupplement',
    defaultMessage: 'Single Supplement',
  },
  singleSupplementTooltip: {
    id: 'fastCover.tugo.tripInterruption.singleSupplementTooltip',
    defaultMessage: 'This benefit only applies when your travelling companion cancels their trip and additional costs are charged to change your commercial accommodation to single',
  },
  outOfPocketExpenses: {
    id: 'fastCover.tugo.tripInterruption.outOfPocketExpenses',
    defaultMessage: 'Out of Pocket Expenses',
  },
  outOfPocketExpensesTooltip: {
    id: 'fastCover.tugo.tripInterruption.outOfPocketExpensesTooltip',
    defaultMessage: 'Tool Tip: Up to the limit of $350 per day to a maximum of $1,500 for your reasonable out-of-pocket expenses for commercial accommodation, meals, internet, telephone and taxi expenses.',
  },
  expensesRelatedToDeath: {
    id: 'fastCover.tugo.tripInterruption.expensesRelatedToDeath',
    defaultMessage: 'Expenses Related to Death',
  },
  returnOfRemains: {
    id: 'fastCover.tugo.tripInterruption.returnOfRemains',
    defaultMessage: 'Return of Remains',
  },
  returnOfRemainsTooltip: {
    id: 'fastCover.tugo.tripInterruption.returnOfRemainsTooltip',
    defaultMessage: 'Preparation and return of your body, including the cost of a standard shipping container (excluding the cost of funeral and related expenses or a burial coffin) to your country of permanent residence.',
  },
  burialCremationPlaceOfDeath: {
    id: 'fastCover.tugo.tripInterruption.burialCremationPlaceOfDeath',
    defaultMessage: 'Burial or Cremation at place of death',
  },
  burialCremationPlaceOfDeathTooltip: {
    id: 'fastCover.tugo.tripInterruption.burialCremationPlaceOfDeathTooltip',
    defaultMessage: 'Up to a maximum of $5,000 for burial at the place of death (excluding the cost of funeral and related expenses or a burial coffin), including one death certificate, in the event your body is not returned to your country of permanent residence; OR Up to a maximum of $5,000 for cremation at the place of death (excluding the cost of funeral and related expenses or an urn), including one death certificate and the standard shipping cost to return your ashes to your country of permanent residence.',
  },
  expenseFor: {
    id: 'fastCover.tugo.tripInterruption.expenseFor',
    defaultMessage: 'Expense for',
  },
  descriptionOfExpense: {
    id: 'fastCover.tugo.tripInterruption.descriptionOfExpense',
    defaultMessage: 'Description of expense',
  },
  dateOfExpense: {
    id: 'fastCover.tugo.tripInterruption.dateOfExpense',
    defaultMessage: 'Date of Expense',
  },
  amountClaimed: {
    id: 'fastCover.tugo.tripInterruption.amountClaimed',
    defaultMessage: 'Amount Claimed',
  },
  providerName: {
    id: 'fastCover.tugo.tripInterruption.providerName',
    defaultMessage: 'Provider Name',
  },
  addExpense: {
    id: 'fastCover.tugo.tripInterruption.addExpense',
    defaultMessage: 'Add Expense',
  },
  travelInterruption: {
    id: 'fastCover.tugo.tripInterruption.travelInterruption',
    defaultMessage: 'Are you claiming for Trip Interruption?',
  },
  reasonsForTripInterruption: {
    id: 'fastCover.tugo.tripInterruption.reasonsForTripInterruption',
    defaultMessage: 'Reasons for Trip Interruption',
  },
  travelSupplier: {
    id: 'fastCover.tugo.tripInterruption.travelSupplier',
    defaultMessage: 'Travel Supplier / Provider Information',
  },
  companyNameTravelInterruption: {
    id: 'fastCover.tugo.tripInterruption.companyNameTravelInterruption',
    defaultMessage: 'Company Name',
  },
  addressTravelInterruption: {
    id: 'fastCover.tugo.tripInterruption.addressTravelInterruption',
    defaultMessage: 'Address',
  },
  cityTravelInterruption: {
    id: 'fastCover.tugo.tripInterruption.cityTravelInterruption',
    defaultMessage: 'City',
  },
  stateTravelInterruption: {
    id: 'fastCover.tugo.tripInterruption.stateTravelInterruption',
    defaultMessage: 'State',
  },
  zipCodeTravelInterruption: {
    id: 'fastCover.tugo.tripInterruption.zipCodeTravelInterruption',
    defaultMessage: 'Zip code',
  },
  contactTravelInterruption: {
    id: 'fastCover.tugo.tripInterruption.contactTravelInterruption',
    defaultMessage: 'Contact',
  },
  phoneNumber: {
    id: 'fastCover.tugo.tripInterruption.phoneNumber',
    defaultMessage: 'Phone Number',
  },
  includedInPackage: {
    id: 'fastCover.tugo.tripInterruption.includedInPackage',
    defaultMessage: 'If not included in package, how was air travel arranged?',
  },
  lossInformation: {
    id: 'fastCover.tugo.tripInterruption.lossInformation',
    defaultMessage: 'Loss Information',
  },
  dateTripInterrupted: {
    id: 'fastCover.tugo.tripInterruption.dateTripInterrupted',
    defaultMessage: 'Date Trip was Interrupted',
  },
  reasonForInterruption: {
    id: 'fastCover.tugo.tripInterruption.reasonForInterruption',
    defaultMessage: 'Reason for interruption',
  },
  nameOfPersonHavingSickness: {
    id: 'fastCover.tugo.tripInterruption.nameOfPersonHavingSickness',
    defaultMessage: 'Name of person having sickness or injury',
  },
  dateOfBirth: {
    id: 'fastCover.tugo.tripInterruption.dateOfBirth',
    defaultMessage: 'His/Her date of birth',
  },
  relationshipToClaimant: {
    id: 'fastCover.tugo.tripInterruption.relationshipToClaimant',
    defaultMessage: 'His/Her relationship to claimant',
  },
  dateSicknessOrInjuryBegan: {
    id: 'fastCover.tugo.tripInterruption.dateSicknessOrInjuryBegan',
    defaultMessage: 'Date Sickness Or Injury began',
  },
  dateEnded: {
    id: 'fastCover.tugo.tripInterruption.dateEnded',
    defaultMessage: 'Date ended',
  },
  natureOfSicknessOrInjury: {
    id: 'fastCover.tugo.tripInterruption.natureOfSicknessOrInjury',
    defaultMessage: 'Nature of Sickness or Injury (If Injury, describe accident, including date and place):',
  },
  periodOfHospitalization: {
    id: 'fastCover.tugo.tripInterruption.periodOfHospitalization',
    defaultMessage: 'Period of hospitalization (If applicable)',
  },
  fromDate: {
    id: 'fastCover.tugo.tripInterruption.fromDate',
    defaultMessage: 'From Date',
  },
  toDate: {
    id: 'fastCover.tugo.tripInterruption.toDate',
    defaultMessage: 'To Date',
  },
  dateOfInitialPaymentDeposit: {
    id: 'fastCover.tugo.tripInterruption.dateOfInitialPaymentDeposit',
    defaultMessage: 'Date of initial payment/deposit',
  },
  insureds: {
    id: 'fastCover.tugo.tripInterruption.insureds',
    defaultMessage: 'Insureds',
  },
  selectInsuredForExpense: {
    id: 'fastCover.tugo.tripInterruption.selectInsuredForExpense',
    defaultMessage: 'Select the insured for this expense',
  },
  selectInsureds: {
    id: 'fastCover.tugo.tripInterruption.selectInsureds',
    defaultMessage: 'Select Insured(s)',
  },
  yes: {
    id: 'fastCover.tugo.tripInterruption.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.tugo.tripInterruption.no',
    defaultMessage: 'No',
  },
  isRequired: {
    id: 'fastCover.tugo.tripInterruption.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  checkEventDate: {
    id: 'fastCover.tugo.tripInterruption.checkEventDate',
    defaultMessage: 'Please enter a valid date for {values}',
  },
  sectionTitle: {
    id: 'fastCover.tugo.tripInterruption.sectionTitle',
    defaultMessage: 'Trip Interruption',
  },
  addLossInformation: {
    id: 'fastCover.tugo.tripInterruption.addLossInformation',
    defaultMessage: 'Add Loss Information',
  },
  lossInformationWithIdx: {
    id: 'fastCover.tugo.tripInterruption.lossInformationWithIdx',
    defaultMessage: 'Loss information {idx}',
  },
  companyNameLoss: {
    id: 'fastCover.tugo.tripInterruption.companyNameLoss',
    defaultMessage: 'Company name (airline/hotel/cruise/travel agent/etc.)',
  },
  dateOfLoss: {
    id: 'fastCover.tugo.tripInterruption.dateOfLoss',
    defaultMessage: 'Date of loss',
  },
  amountPaidLoss: {
    id: 'fastCover.tugo.tripInterruption.amountPaidLoss',
    defaultMessage: 'Amount Paid (total for all insureds)',
  },
  amountOfLoss: {
    id: 'fastCover.tugo.tripInterruption.amountOfLoss',
    defaultMessage: 'Amount of Loss (non-refundable amount)',
  },
  haveYouReceivedReimbursement: {
    id: 'fastCover.tugo.tripInterruption.haveYouReceivedReimbursement',
    defaultMessage: 'Have you received reimbursement?',
  },
  howMuchReceivedReimbursement: {
    id: 'fastCover.tugo.tripInterruption.howMuchReceivedReimbursement',
    defaultMessage: 'How much?',
  },
  fromWhom: {
    id: 'fastCover.tugo.tripInterruption.fromWhom',
    defaultMessage: 'If so, from whom?',
  },
  dateReimbursementReceived: {
    id: 'fastCover.tugo.tripInterruption.dateReimbursementReceived',
    defaultMessage: 'Date Reimbursement Received',
  },
  currency: {
    id: 'fastCover.tugo.tripInterruption.currency',
    defaultMessage: 'Currency',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.TripInterruption/messages.js